import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['toast']
  declare readonly toastTarget: HTMLTemplateElement

  show (): void {
    document.getElementById('toast')?.remove()
    document.body.append(this.toastTarget.content.cloneNode(true))
  }
}
